import React from "react";
import PropTypes from "prop-types";

const SpinnerLabel = ({
  spin,
  className = null,
  spinningLabel = "Processing...",
  label = "",
  icon = null,
  iconClassName = null
}) => {
  if (spin) {
    return (
      <span className={className}>
        <i className={`fa fa-spinner fa-pulse ${iconClassName}`} />
        {spinningLabel}
      </span>
    );
  }

  return (
    <span className={className}>
      {icon && <i className={`fa fa-${icon} mr-1 ${iconClassName}`} />}
      {label}
    </span>
  );
};

SpinnerLabel.propTypes = {
  spin: PropTypes.bool.isRequired,
  spinningLabel: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.string,
  className: PropTypes.string,
  iconClassName: PropTypes.string
};

export default SpinnerLabel;
